import { render } from "./DrawAreaSvg.vue?vue&type=template&id=ea410b2a"
import script from "./DrawAreaSvg.vue?vue&type=script&lang=js"
export * from "./DrawAreaSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__